import React, { ReactNode } from "react";

export interface ImageProps {
  src?: string;
  children?: ReactNode;
}

const Image = ({ src, children }: ImageProps) => {
  return (
    <div
      className="w-full h-full bg-center bg-no-repeat bg-cover"
      style={{
        backgroundImage: `url(${src})`,
      }}
    >
      {children}
    </div>
  );
};

export default Image;
